import React from 'react';
import './BlueSectionDivider.css';

const BlueSectionDivider = () => {
  return <div className="blue-divider" />;
};

export default BlueSectionDivider;
